export const PDF = ['PDF'];
export const IMAGEARR = [
  'JPG',
  'JPEG',
  'PNG',
  'GIF',
  'SVG',
  'PSD',
  'DXF',
  'AI',
  'SKETCH',
  'HEIC',
  'DWG',
  'INDD',
  'FLA',
  'EPS',
  'XCF',
  'CDR',
  'ODG',
];
export const MEDIAARR = [
  'MP3',
  'WAV',
  'FLAC',
  'M4A',
  'm4p',
  'MP4',
  'AVI',
  'MOV',
  'XVID',
  'MKV',
  'OGV',
  'VOB',
  '3GP',
  'MPG',
  'MPE',
  'MPEG',
  'divx',
];
export const ARCHIEVEARR = [
  'GPX',
  'XYZ',
  'EXE',
  'TTF',
  'OTF',
  'WEB',
  'WOFF2',
  'WOFF',
  'ZIP',
  'RAR',
  'GZIP',
  'TAR',
  'GZ',
];
export const XLSARR = [
  'XLS',
  'XLSX',
  'XLSM',
  'XLT',
  'XLTX',
  'CSV',
  'ODS',
  'OTS',
];
export const DOCARR = [
  'DOC',
  'DOCX',
  'DOCB',
  'DOT',
  'DOTX',
  'ODT',
  'OTT',
  'XPS',
  'OXPS',
  'PUB',
  'TXT',
  'RTF',
  'JSON',
  'KEY',
  'NUMBERS',
  'PAGES',
  'GPX',
  'KML',
  'KMZ',
  'VCF',
  'ICS',
  'ICAL',
  'ICALENDAR',
  'IFB',
  'EPUB',
  'MOBI',
  'IPYNB',
];
export const PPTARR = [
  'ODP',
  'OTP',
  'PPS',
  'PPSX',
  'PPT',
  'PPTX',
  'POT',
  'POTX',
];

export const FILETYPE = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  MEDIA: 'MEDIA',
  ARCHIEVE: 'ARCHIEVE',
  XLS: 'XLS',
  DOC: 'DOC',
  PPT: 'PPT',
};
